/**
 * @项目名称: work
 * @功能名称:
 * @文件名称: api
 * @Date: 2019/9/25
 * @Author: liux
 * @Copyright（C）2019 「小赢科技」 Inc.   All rights reserved.
 * 注意：本内容仅限于「小赢科技」内部传阅，禁止外泄以及用于其他的商业目的。
 */
export default {
  // 支付注册接口
  CONTRAST: '/h5/common/get_contract_scene',
  GEETEST:'https://register.xiaoying.com/geetest?t=',
  PAY_PRE_REGISTER:'https://register.xiaoying.com/form/preRegister',
  PAY_REGISTER:'https://register.xiaoying.com/form/register',
  PAY_SILENT_REGISTER:'https://register.xiaoying.com/form/silentRegister',
  PAY_SMS_REGISTER:'https://register.xiaoying.com/form/smsRegister',
  PAY_LOGIN:'https://login.xiaoying.com/login',
  SEND_VERIFY_CODE:'https://login.xiaoying.com/login/sendVerifyCode',
  // 获取落地页配置信息
  LANDING_PAGE_INFO: 'https://opengw.xiaoying.com/api/shared.pandora.popularize_manage/v1/api/landPage/info',
  // 绑定微信openid
  BIND_WECHAT: '/h5/wechat/bind_wechat_info',
  // 获取申请引导
  GET_GUIDE: '/h5/my/get_apply_guide',
  // 上报用户重复注册行为
  REPORT_REGISTER_ASO: 'https://aso.xiaoying.com/api/report/register'
}
